<template>
  <div>
    <div>
      <div class="vx-col sm:w-1/1 w-full mb-6">
        <vx-card
          class="mb-6"
          v-for="(item, index) in integrations"
          :key="index"
        >
          <div>
            <h3>{{ item.integration }}</h3>
            <h5>Envio de apólices p/ {{ item.integration }}</h5>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/4 w-full mt-6">
                <span>Vida</span>
                <vs-switch
                  v-model="integrations[index].sendPolicyLife"
                  color="success"
                  style="width: 80px"
                >
                  <span slot="on">Enviar</span>
                  <span slot="off">Não enviar</span>
                </vs-switch>
              </div>
              <div class="vx-col sm:w-1/4 w-full mt-6">
                <span>Microvida</span>
                <vs-switch
                  v-model="integrations[index].sendPolicyMicroLife"
                  color="success"
                  style="width: 80px"
                >
                  <span slot="on">Enviar</span>
                  <span slot="off">Não enviar</span>
                </vs-switch>
              </div>
              <div class="vx-col sm:w-1/4 w-full mt-6">
                <span>Auto</span>
                <vs-switch
                  v-model="integrations[index].sendPolicyAuto"
                  color="success"
                  style="width: 80px"
                >
                  <span slot="on">Enviar</span>
                  <span slot="off">Não enviar</span>
                </vs-switch>
              </div>
            </div>
            <div class="w-full flex justify-end">
              <vs-button @click="updateSendConfigs(integrations[index])" color="success"
                >Salvar Alterações</vs-button
              >
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <div class="vx-row mb-6" v-for="item in integracoes" :key="item.id">
      <div class="vx-col sm:w-1/1 w-full">
        <vx-card>
          <h3>{{ item.nomeFornecedor }}</h3>
          <div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full mt-4">
                <formIntegracao :objUpdate="item" @concluido="buscaDados()" />
              </div>
              <div v-if="item.possuiDePara" class="vx-col sm:w-2/3 w-full mt-4">
                <button
                  class="vs-component vs-button vs-button-primary vs-button-gradient"
                  @click="openDePara(item)"
                  type="gradient"
                >
                  De/Para
                </button>
                <formIntegracaoDePara
                  :objUpdate="item.dePara"
                  :objGeral="item"
                  @concluido="openDePara(item)"
                />
              </div>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import service from './../../../services';
import locale from './../../../locale';
import Datepicker from 'vuejs-datepicker';
import { Money } from 'v-money';
import BotaoSubmit from '../../../components/BotaoSubmit';
import formIntegracao from './../../forms/formIntegracao.vue';
import formIntegracaoDePara from './../../forms/formIntegracaoDePara.vue';
import notify from '../../../utils/notify';
import integrationApiService from "../../../services/integration.api";

export default {
  components: {
    Datepicker,
    Money,
    BotaoSubmit,
    formIntegracao,
    formIntegracaoDePara,
  },
  data() {
    return {
      aguardeCadastro: false,
      integracoes: [],
      form: {},
      passo: 0,
      controller: 'integrations',
      action: 'sendconfigs',
      integrations: [],
    };
  },
  methods: {
    async getSendConfigs() {
      this.$vs.loading();
      try {
        this.integrations = await integrationApiService.getAllSendConfigs();
      } catch (error) {
        notify.notifyFail(this.$vs, "Erro ao buscar configurações de envio");
      } finally {
        this.$vs.loading.close();
      }
    },
    async updateSendConfigs(data) {
      this.$vs.loading();
      try {
        await integrationApiService.updateSendConfigs(data);
        notify.notifySuccess(this.$vs, 'Dados atualizados!');
      } catch (error) {
        notify.notifyFail(this.$vs, "Erro ao atualizar configurações de envio");
      } finally {
        this.$vs.loading.close();
      }
    },
    openDePara(item) {
      this.aguardeCadastro = true;
      this.$vs.loading();
      service
        .post('integracoes', 'buscaDePara', item)
        .then((res) => {
          this.aguardeCadastro = false;
          this.$vs.loading.close();
          item.dePara = res.data;
          this.$forceUpdate();
        })
        .catch((error) => {
          this.aguardeCadastro = false;
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: error,
            color: 'danger',
          });
        });
    },
    onSubmit() {
      this.form.dadosProposta = this.dadosProposta;

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.aguardeCadastro = true;
          this.$vs.loading();
          service
            .post('Cotacao', 'AtualizarPropostaGeral', this.form)
            .then((res) => {
              this.aguardeCadastro = false;
              this.$vs.loading.close();
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: `Operação Realizada com sucesso`,
                color: 'success',
              });
              this.$emit('concluido');
              this.buscaDados();
            })
            .catch((error) => {
              this.aguardeCadastro = false;
              this.$vs.loading.close();
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: error,
                color: 'danger',
              });
            });
        }
      });
    },
    preencheForm() {},
    buscaDados() {
      this.$vs.loading();
      var objSend = {};
      objSend.idEmpresa = this.idEmpresa;
      objSend.notDeleted = true;
      service
        .post('integracoes', 'list', objSend)
        .then((res) => {
          this.integracoes = [];
          if (res.data.length > 0) {
            res.data.forEach((element) => {
              if (element.jsonFacilitador) {
                element.jsonFacilitador = JSON.parse(element.jsonFacilitador);
                element.parametros = element.parametros
                  ? JSON.parse(element.parametros)
                  : {};
                this.integracoes.push(element);
              }
            });
            this.$vs.loading.close();
          } else {
            this.$vs.loading.close();
          }
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },

    buscaDadosSelectsPorEmpresa(model, array, campoDescricao, campoPK) {
      service
        .getAll('g', {}, `${model}/list/idEmpresa/idEmpresa=${this.idEmpresa}`)
        .then((res) => {
          this[array].push({ label: 'Selecione', id: null });
          res.data.forEach((element) => {
            element.id = element[campoPK];
            element.label = element[campoDescricao];
            this[array].push(element);
          });
        });
    },
    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll('g', {}, `${model}/list/`).then((res) => {
        res.data.forEach((element) => {
          this[array].push({
            id: element[campoPK],
            label: element[campoDescricao],
          });
        });
      });
    },
  },
  mounted() {
    this.$validator.localize('ptBr', locale);
    this.buscaDados();
    this.getSendConfigs();
  },
};
</script>
<style>
.vdp-datepicker input {
  width: 100%;
}
</style>

<style scoped lang="scss">
.table-bordered {
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: grey;
  width: 100%;
  tr td {
    padding: 2px;
  }
  tr:nth-child(2n) {
    background: #efefef !important;
  }
}
.vs-tabs-primary .activeChild button,
.vs-tabs-primary button:not(:disabled):hover {
  color: #fff !important;
}
.forceWhite:hover {
  color: #fff !important;
}
</style>
